export default "__VITE_ASSET__BCa2eGrI__"